import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

const WhyFitifyIsBetterSection = () => {
  const features = [
    {
      id: 1,
      icon: (
        <Box
          sx={{
            width: "24px",
            height: "24px",
            background:
              "linear-gradient(45deg, #000 0%, #000 50%, transparent 50%, transparent 100%)",
            clipPath:
              "polygon(0% 0%, 100% 0%, 100% 60%, 60% 60%, 60% 100%, 0% 100%)",
          }}
        />
      ),
      title: "Personalized Diet Plans",
      description:
        "No two people are the same, and neither are their health goals. Fitify creates personalized meal plans and reminders designed around your unique preferences, activity level, and nutrition needs so you always feel supported, never restricted.",
    },
    {
      id: 2,
      icon: (
        <Box
          sx={{
            width: "24px",
            height: "24px",
            background:
              "linear-gradient(45deg, #000 0%, #000 20%, transparent 20%, transparent 40%, #000 40%, #000 60%, transparent 60%, transparent 80%, #000 80%, #000 100%)",
            clipPath:
              "polygon(0% 100%, 20% 80%, 40% 100%, 60% 60%, 80% 80%, 100% 40%, 80% 20%, 60% 40%, 40% 0%, 20% 20%, 0% 0%)",
          }}
        />
      ),
      title: "All in One Tracking",
      description:
        "Fitify combines powerful tools into one easy platform. From meals and hydration to workouts and progress stats, everything is tracked in real time. Clear insights and progress charts keep you motivated and accountable every step of the way.",
    },
    {
      id: 3,
      icon: (
        <Box
          sx={{
            width: "24px",
            height: "24px",
            background:
              "linear-gradient(45deg, #000 0%, #000 30%, transparent 30%, transparent 70%, #000 70%, #000 100%)",
            clipPath:
              "polygon(0% 0%, 100% 0%, 100% 20%, 80% 20%, 80% 40%, 100% 40%, 100% 60%, 80% 60%, 80% 80%, 100% 80%, 100% 100%, 0% 100%)",
          }}
        />
      ),
      title: "Smart Reminders",
      description:
        "We don't just help you eat better we help you live better. With gentle reminders to hydrate, fuel up, and move daily, Fitify makes consistency second nature. Over time, these small daily habits lead to big life changing results.",
    },
    {
      id: 4,
      icon: (
        <Box
          sx={{
            width: "24px",
            height: "24px",
            background:
              "radial-gradient(circle at 50% 50%, #000 0%, #000 40%, transparent 40%, transparent 100%)",
            borderRadius: "50%",
          }}
        />
      ),
      title: "Insights That Matter",
      description:
        "Forget fad diets and quick fixes. Fitify focuses on long term well being. With flexible plans, realistic goals, and a supportive system, you'll achieve results you can actually maintain building confidence, energy, and vitality that last.",
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 8, position: "relative", zIndex: 2 }}>
      {/* Section Header */}
      <Box sx={{ textAlign: "center", mb: 8 }}>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" },
            fontWeight: 700,
            fontFamily: "Outfit",
            color: "#4ef4ff",
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          Why Fitify is Better
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "1rem", md: "1.2rem" },
            fontWeight: 400,
            fontFamily: "Outfit",
            color: "#FFFFFF",
            lineHeight: 1.6,
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          Unlike one size fits all diets, Fitify is built to adapt to YOU — your
          lifestyle, your goals, your pace.
        </Typography>
      </Box>

      {/* Main Feature Container */}
      <Box
        sx={{
          backgroundColor: "#242424",
          borderRadius: "20px",
          padding: { xs: "32px 24px", md: "48px 40px", lg: "60px 50px" },
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Feature Blocks Grid */}
        <Grid container spacing={{ xs: 4, md: 6 }}>
          {features.map((feature) => (
            <Grid item xs={12} md={6} key={feature.id}>
              <Box sx={{ height: "100%" }}>
                {/* Icon */}
                <Box
                  sx={{
                    width: "48px",
                    height: "48px",
                    backgroundColor: "#4ef4ff",
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 3,
                  }}
                >
                  {feature.icon}
                </Box>

                {/* Title */}
                <Typography
                  sx={{
                    fontSize: { xs: "1.3rem", md: "1.5rem" },
                    fontWeight: 700,
                    fontFamily: "Outfit",
                    color: "#FFFFFF",
                    mb: 2,
                  }}
                >
                  {feature.title}
                </Typography>

                {/* Description */}
                <Typography
                  sx={{
                    fontSize: { xs: "0.95rem", md: "1rem" },
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    color: "rgba(255, 255, 255, 0.8)",
                    lineHeight: 1.6,
                  }}
                >
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default WhyFitifyIsBetterSection;
